import * as React from 'react';
import { GridContextProps, withGridContext } from '../grid/GridContext';
import { ColumnProps } from '../column/Column';
import { StyledRowDiv } from './styledRowDiv';

export interface RowProps {
  children: React.ReactElement<ColumnProps> | React.ReactElement<ColumnProps>[];
}

const Row: React.SFC<RowProps & GridContextProps> = ({ children, grid }) => {
  return (
    <StyledRowDiv grid={grid}>{children}</StyledRowDiv>
  );
};

export default withGridContext(Row);
